export function fgetName(vv1) {
  if (vv1.expenseItem) {
    return vv1.expenseItemType.name
  } else if (vv1.daysItem) {
    return vv1.expenseDaysType.name
  } else if (vv1.templateField) {
    return vv1.templateField.desc
  } else {
    return vv1.fieldName
  }
}

export function fgetNameAlias(vv1) {
  if (vv1.expenseItem) {
    return vv1.expenseItemType.name
  } else if (vv1.daysItem) {
    return vv1.expenseDaysType.name
  } else if (vv1.templateField) {
    return vv1.alias || vv1.templateField.desc
  } else {
    return vv1.fieldName
  }
}

export function fitemType(vv1) {
  if (vv1.expenseItem) {
    return '费用项'
  } else if (vv1.daysItem) {
    return '天数'
  } else if (vv1.templateField) {
    return vv1.templateField.fieldTypeDesc
  } else {
    return vv1.fieldName
  }
}
